import React from 'react';
import { ZoomIn, ZoomOut, RefreshCw } from 'lucide-react';

const MapZoomControls = ({ onZoomIn, onZoomOut, onReset }) => {
  return (
    <div className="absolute bottom-6 right-6 z-[1000] flex flex-col space-y-2 bg-white p-1.5 rounded-lg shadow-xl border border-gray-100">
      <button
        onClick={onZoomIn}
        className="p-2 bg-white hover:bg-gray-50 text-gray-700 hover:text-gray-900 rounded-md transition-colors border border-gray-100 flex items-center justify-center shadow-sm"
        title="Acercar mapa"
      >
        <ZoomIn className="w-4 h-4" />
      </button>
      <button
        onClick={onZoomOut}
        className="p-2 bg-white hover:bg-gray-50 text-gray-700 hover:text-gray-900 rounded-md transition-colors border border-gray-100 flex items-center justify-center shadow-sm"
        title="Alejar mapa"
      >
        <ZoomOut className="w-4 h-4" />
      </button>
      <button
        onClick={onReset}
        className="p-2 bg-white hover:bg-gray-100 text-gray-700 hover:text-gray-900 rounded-md transition-colors border border-gray-100 flex items-center justify-center shadow-sm"
        title="Restablecer vista"
      >
        <RefreshCw className="w-4 h-4" />
      </button>
    </div>
  );
};

export default MapZoomControls;
